import type { Field } from './types.tsx';

export const FIXED_IN: Field = {
	id: 'fixVersion',
	name: 'Fix Version',
};

export const AFFECTS: Field = {
	id: 'affectedVersion',
	name: 'Affects version',
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default [FIXED_IN, AFFECTS];
